export const getParameterByName = (name, url) => {
  name = name.replace(/[[]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url ? url : window.location.href);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const selected = process.env.REACT_APP_COMPANY || window.COMPANY || getParameterByName("company");
/* eslint-disable eqeqeq */
const inFrame = !!getParameterByName("iframe") || (window != window.top);

export const config = () => {
  const d = {
    name: selected,
    theme: 'default',
    inFrame,
    colorConfig: {
      main: '#0a2f70', //''#93bc22',
      header: '#0a2f70',
      bkPanel: '#f4f8e8'
    },
    colors: {
      futureHousePrice: '#0d555f', // '#93bc22', // '#62ad4e',
      noRepayments: '#0a2f70', // '#125b2e', // '#00b0a9',0a2f70
      payingOffInterest: '#03a6a6', // '#7030a0',0a2f70
      partialRepayment: '#51bba4', // '#ff0000'
    },
    bkColors: {
      futureHousePrice: '#eaf5ed', // '#f4f8e8',
      noRepayments: '#f1f1f1', // '#d8e4dd', // '#00b0a9',
      payingOffInterest: '#f1f1f1', // '#d9f2f2', // '#f0eaf5', // '#7030a0',
      partialRepayment: '#e6e9e8', // '#e8f0f0' // '#ff0000'
    },
    titles: {
      futureHousePrice: 'Future house price',
      partialRepayment: 'Partial repayment',
      payingOffInterest: 'Paying interest',
      noRepayments: 'No repayments'
    }
  }

  if (selected === 'partialrepayments') {
    d.theme = "navy";
    d.colorConfig.main = "#00add6";
    d.colorConfig.header = "#00add6";
    d.colors.futureHousePrice = "#2a2460";
    d.colors.partialRepayment = "#a4a4be";
    d.colors.noRepayments = "#00add6";
  }

  if (!process.env.REACT_APP_PAYING_INTEREST) {
    delete d.colors.payingOffInterest;
    delete d.bkColors.payingOffInterest;
    delete d.titles.payingOffInterest;
  }
  return d
}



// WEBPACK FOOTER //
// ./src/config/config.js